import dplusgtmsnippets from "./dplusgtmsnippets";
const dataScriptFunction = (dataLayer) => {
    const script = document.createElement("script");
    script.innerHTML = dataLayer;
    return script;
};
const gtmfunction = (args) => {
    const snippets = dplusgtmsnippets.tag(args);
    const noScript = () => {
        return snippets.iframe;
    };
    const script = () => {
        return snippets.script;
    };
    const dataScript = dataScriptFunction(snippets.dataLayerVar);
    return {
        noScript,
        script,
        dataScript,
    };
};
const initializefunction = ({ id }) => {
    const gtm = gtmfunction({ id: id });
    document.head.appendChild(gtm.dataScript);
    return {
        gtmScript: gtm.script(),
        gtmNoScript: gtm.noScript(),
    };
};
const dplusGtagManager = {
    dataScript: dataScriptFunction,
    gtm: gtmfunction,
    initialize: initializefunction,
};
export default dplusGtagManager;

